import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const aioliAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.AioliEnabled],
  permissions: [Permission.AioliExecute],
  featureEntitlementIds: [FeatureEntitlements.Aioli],
}
